"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_use_1 = require("react-use");
const store_1 = require("../../store");
const DrawerMenu_styles_1 = require("./DrawerMenu.styles");
exports.DrawerContainer = (0, react_1.forwardRef)(function DrawerContainer({ children, id }, ref) {
    const optionMenu = (0, store_1.useMenu)();
    const menuDispatch = (0, store_1.useMenuDispatch)();
    //TODO: change useClickAway to useClickOutside
    (0, react_use_1.useClickAway)(ref, (event) => {
        var _a, _b, _c;
        if (!event || !event.target)
            return;
        if (!optionMenu.SECTION.isVisible || optionMenu.SECTION.name !== id)
            return;
        if (((_a = event.target) === null || _a === void 0 ? void 0 : _a.closest('.ant-dropdown')) ||
            ((_b = event.target) === null || _b === void 0 ? void 0 : _b.closest('.ant-popover')) ||
            ((_c = event.target) === null || _c === void 0 ? void 0 : _c.closest('.dropdown-container')))
            return;
        menuDispatch({
            type: 'SET_SECTION',
            payload: {
                isVisible: false,
                name: null,
            },
        });
    });
    return ((0, jsx_runtime_1.jsx)(DrawerMenu_styles_1.StyledDrawerContainer, { isOpened: optionMenu.SECTION.name === id, isToolbarVisible: optionMenu.isToolbarVisible, ref: ref, children: (0, jsx_runtime_1.jsx)(DrawerMenu_styles_1.StyledSectionContainer, { isOpened: optionMenu.SECTION.name === id, isToolbarVisible: optionMenu.isToolbarVisible, children: children }) }));
});
//# sourceMappingURL=DrawerMenu.js.map